









































import CompanySheet from "@/components/company/CompanySheet.vue";
import ConfirmActionDialog from "@/components/utility/ConfirmActionDialog.vue";
import MIconButton from "@/components/utility/mmmint/MIconButton.vue";
import MNoContent from "@/components/utility/mmmint/MNoContent.vue";
import { CompanyServiceEnum } from "@/lib/enum/company-service.enum";
import { handleError } from "@/lib/utility/handleError";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { ICompany } from "@/models/company.entity";
import { PartnerModule } from "@/store/modules/partner";
import { mixins } from "vue-class-component";
import { Component, Watch } from "vue-property-decorator";
import CompanySelection from "../contact/CompanySelection.vue";

@Component({
  components: {
    MIconButton,
    MNoContent,
    CompanySheet,
    CompanySelection,
    ConfirmActionDialog
  },
  filters: {}
})
export default class PartnerReportSelectRentalCompanyCard extends mixins(PermissionMixin) {
  get partner() {
    return PartnerModule.partner;
  }

  get report() {
    return PartnerModule.report;
  }

  isUpdatingReport = false;
  selectDialog = false;
  filter = CompanyServiceEnum.RENTAL;

  localRentalCompany: ICompany | null = null;

  get rentalCompanyId() {
    return this.report.rentalCompanyId;
  }

  get selectIcon() {
    if (this.rentalCompanyId) {
      return "mdi-pencil-outline";
    }
    return "mdi-plus";
  }

  openDialog() {
    if (this.report.rentalCompany) {
      this.localRentalCompany = this.report.rentalCompany;
    } else {
      this.localRentalCompany = null;
    }

    this.selectDialog = true;
  }

  async selectRental() {
    this.isUpdatingReport = true;

    (await this.report
      .updatePartial({ rentalCompanyId: this.localRentalCompany?.id || null })
      .catch(error => handleError(error))) || null;
    await this.fetchRental();

    this.isUpdatingReport = false;

    this.selectDialog = false;
  }

  @Watch("report", { immediate: true })
  onReportChanged() {
    if (this.report?.rentalCompanyId) {
      this.fetchRental();
    }
  }

  private async fetchRental() {
    await this.report.fetchRentalCompany().catch(handleError);
  }
}
